// src/components/ui/ProductImage.jsx
import React, { useState } from 'react';

/**
 * Composant pour gérer les images de produits avec fallbacks
 * @param {Object} props - Propriétés du composant
 * @param {string} props.src - URL de l'image
 * @param {string} props.alt - Texte alternatif
 * @param {string} props.productCode - Code du produit pour les fallbacks
 * @param {string} props.className - Classes CSS additionnelles
 */
const ProductImage = ({ src, alt, productCode, className = '' }) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [fallbackIndex, setFallbackIndex] = useState(0);
  
  // Tableau de chemins d'accès pour tenter de trouver une image valide
  const fallbackPaths = [
    // Chemin original
    src,
    // Fallback 1: Version sans "-large" ou "-small"
    `/images/${productCode}.png`,
    // Fallback 2: Basé seulement sur le code produit principal (avant le tiret)
    productCode ? `/images/${productCode.split('-')[0]}.png` : null,
    // Fallback 3: Image de catégorie générique 
    src.includes('eau') || src.includes('vitale') || src.includes('tangui') 
      ? '/images/water-generic.png' 
      : src.includes('cola') || src.includes('soda') || src.includes('gazeu')
        ? '/images/soda-generic.png'
        : '/images/drink-generic.png',
    // Fallback final: Image placeholder
    '/images/placeholder-product.png'
  ].filter(Boolean); // Retirer les chemins null ou undefined

  const handleImageError = () => {
    // Essayer le prochain fallback s'il y en a encore
    const nextIndex = fallbackIndex + 1;
    if (nextIndex < fallbackPaths.length) {
      setFallbackIndex(nextIndex);
      setImageSrc(fallbackPaths[nextIndex]);
    }
  };

  return (
    <img 
      src={imageSrc}
      alt={alt}
      className={className}
      onError={handleImageError}
    />
  );
};

export default ProductImage;